module.exports = __webpack_public_path__ + "static/img/a2.4c96464a.png";